import { getAuthorizationUri } from '../services/getAuthorizationUri';

export function connectGmail(): void {
    const height = 700;
    const width = 600;
    const top = (window.screen.height - height) / 2;
    const left = (window.screen.width - width) / 2;
    let gmailWindow = window.open(
        '',
        '_blank',
        `width=${width},height=${height},top=${top},left=${left},menubar=no,status=no,scrollbars=no,titlebar=no,toolbar=no,resizable=yes`
    );

    getAuthorizationUri().then(response => {
        if (!response.ErrorMessage) {
            gmailWindow.location.href = response.OAuth2AuthorizationEndpointInfo.AuthorizationUri;
        }
    });
}
